import { AxiosInstance } from 'axios'
import {
    LoginRequest,
    LoginResponse,
    InvitationInfo,
    SetPasswordRequest,
    RefreshTokenRequest,
    RefreshTokenResponse,
    LogoutRequest,
} from './auth.type'
import { User } from '../user'

export class AuthApi {
    constructor(private readonly client: AxiosInstance) {}

    async login(payload: LoginRequest): Promise<LoginResponse> {
        const response = await this.client.post<LoginResponse>('/auth/login', payload)
        return response.data
    }

    async azureCallback(code: string, sessionState: string): Promise<LoginResponse> {
        const response = await this.client.get<LoginResponse>('/auth/azure/callback', {
            params: { code, session_state: sessionState },
        })
        return response.data
    }

    async getMe(): Promise<User> {
        const response = await this.client.get<User>('/v1/auth/me')
        return response.data
    }

    async getUserByToken(token: string): Promise<InvitationInfo> {
        const response = await this.client.get<InvitationInfo>('/auth/user-by-token', {
            params: { token },
        })
        return response.data
    }

    async setPassword(payload: SetPasswordRequest): Promise<LoginResponse | void> {
        const response = await this.client.post<LoginResponse>('/auth/set-password', payload)
        // Backend may return LoginResponse (auto-login) or void
        return response.data
    }

    async refresh(payload: RefreshTokenRequest): Promise<RefreshTokenResponse> {
        const response = await this.client.post<RefreshTokenResponse>('/auth/refresh', payload)
        return response.data
    }

    async logout(payload: LogoutRequest): Promise<void> {
        await this.client.post('/auth/logout', payload)
    }
}
